import React from 'react';
import { useRouter } from '@/navigation';
import { useSearchParams } from 'next/navigation';
import styles from './clear-search-filters.module.scss';

type Props = {
  displayText: string;
};

export default function ClearSearchFilters({ displayText }: Props) {
  // https://next-intl-docs.vercel.app/docs/routing/navigation#userouter
  const router = useRouter();
  // https://nextjs.org/docs/app/api-reference/functions/use-search-params
  const searchParams = useSearchParams();

  // Clear All Filter will not be active when
  // Search Query Param is EMPTY, means size 0
  // Search Query Param only has one param i.e. keyword and query param size 1
  function isFilterInactive() {
    return searchParams.size === 0 || (!!searchParams.get(`keyword`) && searchParams.size === 1);
  }

  function clearQueryParam() {
    // get keyword param value and push to router
    if (searchParams.get(`keyword`)) {
      const keyword = searchParams.get(`keyword`)?.toString();
      router.push(`/search?keyword=${keyword}`);
    } else {
      // else reset the search route
      router.push(`/search`);
    }
  }
  return (
    <button
      className={`${styles[`clear-filter`]}`}
      id="clearFilters"
      disabled={isFilterInactive()}
      onClick={clearQueryParam}
      type="button"
    >
      {displayText}
    </button>
  );
}
